interface IconProps {
  fillColor: string
}

export const SuccessIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="121"
        height="120"
        viewBox="0 0 121 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M71.294 54.1419C71.7406 53.7034 71.747 52.9858 71.3084 52.5392C70.8698 52.0927 70.1523 52.0862 69.7057 52.5248L56.9313 65.0711L51.9679 60.1077C51.5253 59.6651 50.8077 59.6651 50.3652 60.1077C49.9226 60.5503 49.9226 61.2679 50.3651 61.7105L56.9169 68.2623L71.294 54.1419Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.5 60C92.5 77.6731 78.1731 92 60.5 92C42.8269 92 28.5 77.6731 28.5 60C28.5 42.3269 42.8269 28 60.5 28C78.1731 28 92.5 42.3269 92.5 60ZM90.2333 60C90.2333 76.4213 76.9213 89.7333 60.5 89.7333C44.0787 89.7333 30.7667 76.4213 30.7667 60C30.7667 43.5787 44.0787 30.2667 60.5 30.2667C76.9213 30.2667 90.2333 43.5787 90.2333 60Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
